import styled from 'styled-components';

export const LocationPickerArea = styled.div`
  width: 100%;
  
  .location-layout {
    display: flex;
    gap: 20px;
    align-items: flex-start;

    @media (max-width: 900px) {
      flex-direction: column;
    }
  }

  .map-section {
    flex: 1;
    min-width: 0;
  }

  .postal-section {
    width: 300px;
    flex-shrink: 0;

    @media (max-width: 900px) {
      width: 100%;
    }

    .postal-input-group {
      margin-bottom: 15px;

      label {
        display: block;
        font-weight: 600;
        font-size: 15px;
        margin-bottom: 8px;
        color: #333;
      }

      input {
        width: 100%;
        padding: 12px 15px;
        border: 2px solid #ddd;
        border-radius: 8px;
        font-size: 15px;
        transition: all 0.3s;

        &:focus {
          outline: none;
          border-color: #667eea;
          box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);
        }
      }

      button {
        width: 100%;
        margin-top: 10px;
        padding: 12px;
        background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
        color: white;
        border: none;
        border-radius: 8px;
        font-size: 15px;
        font-weight: 600;
        cursor: pointer;
        transition: all 0.3s;

        &:hover {
          transform: translateY(-2px);
          box-shadow: 0 4px 12px rgba(102, 126, 234, 0.4);
        }

        &:disabled {
          opacity: 0.6;
          cursor: not-allowed;
          transform: none;
        }
      }
    }

    .info-text {
      font-size: 13px;
      color: #666;
      line-height: 1.5;
      padding: 12px;
      background: #f8f9fa;
      border-radius: 8px;
      margin-top: 15px;
    }

    .postal-result {
      margin-top: 15px;
      padding: 15px;
      background: linear-gradient(135deg, #e8f5e9 0%, #c8e6c9 100%);
      border-radius: 8px;
      border-left: 4px solid #4caf50;

      strong {
        display: block;
        color: #2e7d32;
        margin-bottom: 8px;
        font-size: 14px;
      }

      .postal-code-display {
        font-size: 20px;
        font-weight: 700;
        color: #1b5e20;
        letter-spacing: 2px;
      }

      .location-info {
        margin-top: 10px;
        padding-top: 10px;
        border-top: 1px solid #a5d6a7;
        font-size: 14px;
        color: #2e7d32;
        font-weight: 500;
      }
    }
  }
  
  .map-controls {
    display: flex;
    flex-direction: column;
    gap: 15px;
    margin-bottom: 20px;

    .location-btn {
      background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
      color: white;
      border: none;
      padding: 18px 32px;
      border-radius: 10px;
      font-size: 18px;
      font-weight: 600;
      cursor: pointer;
      transition: all 0.3s ease;
      box-shadow: 0 3px 10px rgba(102, 126, 234, 0.3);

      &:hover {
        transform: translateY(-2px);
        box-shadow: 0 6px 16px rgba(102, 126, 234, 0.4);
      }

      &:disabled {
        opacity: 0.6;
        cursor: not-allowed;
        transform: none;
      }
    }

    .error-text {
      color: #e74c3c;
      font-size: 15px;
      font-weight: 500;
    }

    .success-text {
      color: #27ae60;
      font-size: 15px;
      font-weight: 500;
    }

    .help-text {
      color: #7f8c8d;
      font-size: 15px;
      font-style: italic;
      line-height: 1.5;
    }
  }

  .leaflet-container {
    border: 3px solid #e0e0e0;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.12);
    min-height: 350px;
    border-radius: 12px;
    width: 100%;
  }
`;
